<template>
  <footer class="footer-bar">
    <div class="footer-content">
      <!-- 主要信息区域 -->

      <div class="footer-main">
        <!-- 平台信息 -->

        <div class="platform-section">
          <div class="platform-info">
            <h3 class="platform-name">三火私服</h3>

            <p class="platform-desc">为您提供优质的服务</p>
          </div>
        </div>

        <!-- 联系信息 -->

        <div class="contact-section">
          <div
            class="contact-item"
            v-if="platformInfo.phone"
            @click="contactCustomerService"
          >
            <i class="el-icon-chat-dot-round"></i>

            <span>微信客服：{{ platformInfo.phone }}</span>
          </div>

          <div class="contact-item" v-if="platformInfo.email">
            <i class="el-icon-message"></i>

            <span>{{ platformInfo.email }}</span>
          </div>
        </div>

        <!-- 快速链接 -->

        <div class="quick-links">
          <a class="link-item" @click="openDocument('privacy')">隐私协议</a>

          <a class="link-item" @click="openDocument('service')">服务协议</a>

          <a class="link-item" @click="openDocument('rules')">平台规则</a>

          <a class="link-item" @click="openDocument('manual')">用户手册</a>

          <a class="link-item" @click="previewQualification">平台资质</a>
        </div>

        <!-- 版权信息 -->

        <div class="copyright-section">
          <p class="icp-info">蜀ICP备2023041365号-2</p>
          <p class="icp-info">川公网安备51019002008398号</p>
          <p class="company-info">Copyright © 成都菁融智汇信息科技有限公司</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "FooterBar",
  computed: {
    ...mapState("user", ["userInfo"]),
    // 平台信息
    platformInfo() {
      const platform = (this.userInfo && this.userInfo.platform) || {};
      return {
        version: platform.version || "1.0.0",
        phone: platform.phone || "",
        email: platform.email || platform.emil || "", // 兼容拼写错误
      };
    },
  },
  data() {
    return {
      // PDF文档资源URL
      documentUrls: {
        privacy: "https://admin.sanhsf.com/images/三火私服隐私协议.pdf",
        rules: "https://admin.sanhsf.com/images/三火私服平台规则.pdf",
        service: "https://admin.sanhsf.com/images/三火私服服务协议.pdf",
        manual: "https://admin.sanhsf.com/images/三火私服用户手册.pdf",
      },
      // 平台资质图片URL
      qualificationImageUrl: "https://admin.sanhsf.com/images/平台资质.jpg",
    };
  },
  methods: {
    /**
    /**
     * 联系客服
     */
    contactCustomerService() {
      if (this.platformInfo.phone) {
        // 这里可以根据需要实现具体的联系逻辑
        // 比如复制到剪贴板、打开微信等
        this.showMessage(`客服微信：${this.platformInfo.phone}`, "info");

        // 如果需要复制到剪贴板
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(this.platformInfo.phone)
            .then(() => {
              this.showMessage("客服微信已复制到剪贴板", "success");
            })
            .catch(() => {
              console.log("复制失败");
            });
        }
      }
    },

    /**
     * 显示消息提示
     */
    showMessage(message, type = "info") {
      // 简单实现
      alert(message);
    },

    /**
     * 打开文档
     * @param {string} type - 文档类型
     */
    async openDocument(type) {
      const url = this.documentUrls[type];
      if (!url) {
        this.showMessage("文档地址不存在", "error");
        return;
      }

      try {
        // 在新窗口中打开PDF文档
        window.open(url, "_blank");
      } catch (error) {
        console.error("打开文档失败:", error);
        this.showMessage("打开文档失败，请稍后重试", "error");
      }
    },

    /**
     * 预览平台资质图片
     */
    previewQualification() {
      try {
        // 创建一个新窗口来显示图片
        const imageWindow = window.open("", "_blank");
        imageWindow.document.write(`
          <html>
            <head>
              <title>平台资质</title>
              <style>
                body { 
                  margin: 0; 
                  padding: 20px; 
                  background: #f5f5f5; 
                  display: flex; 
                  justify-content: center; 
                  align-items: center; 
                  min-height: 100vh;
                }
                img { 
                  max-width: 100%; 
                  max-height: 100%; 
                  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
                  border-radius: 8px;
                }
              </style>
            </head>
            <body>
              <img src="${this.qualificationImageUrl}" alt="平台资质" />
            </body>
          </html>
        `);
      } catch (error) {
        console.error("预览资质图片失败:", error);
        // 使用Element UI的Message组件显示错误信息
        this.$message({
          message: "预览失败，请稍后重试",
          type: "error",
        });
      }
    },
  },
};
</script>

<style scoped>
.footer-bar {
  position: relative;
  background: linear-gradient(135deg, #2c2c2c 0%, #1a1a1a 100%);
  border-top: 2px solid #e74c3c;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 24px;
  color: #e0e0e0;
}

/* 主要内容区域 */
.footer-main {
  display: grid;
  grid-template-columns: 2fr 1.5fr 1fr 1.5fr;
  gap: 24px;
  align-items: center;
}

/* 平台信息 */
.platform-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.platform-info h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 2px 0;
  color: #e74c3c;
}

.platform-desc {
  font-size: 12px;
  margin: 0;
  color: #aaa;
}

/* 联系信息 */
.contact-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.contact-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #ccc;
  cursor: pointer;
  transition: color 0.2s ease;
}

.contact-item:hover {
  color: #e74c3c;
}

.contact-item i {
  margin-right: 6px;
  width: 14px;
  text-align: center;
  color: #e74c3c;
}

/* 快速链接 */
.quick-links {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.link-item {
  font-size: 13px;
  color: #ccc;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
  white-space: nowrap;
}

.link-item:hover {
  color: #fff;
}

/* 版权信息 */
.copyright-section {
  text-align: right;
}

.copyright-section p {
  margin: 0;
  font-size: 11px;
  color: #888;
  line-height: 1.4;
}

.icp-info {
  margin-bottom: 2px !important;
}
</style>
